import React, { useReducer } from 'react';
import { DataContext, initialState, reducer } from '../stores/crm-active-deals-store';

const CrmActiveDealsContextWrapper = ({ children }) => {
    const [store, dispatch] = useReducer(reducer, initialState);

    return <DataContext.Provider value={{ store, dispatch }}>{children}</DataContext.Provider>;
};

export default CrmActiveDealsContextWrapper;
